import line from "../../assets/img/arrow-icon.png";
import { howItWorkList } from "../common/Helper";

const HowItWorksCard = () => {
  return (
    <div className="grid xl:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 w-full sm:mt-10 mt-7 xl:pb-20 md:pt-28 gap-5 relative">
      <img
        className="absolute hidden md:block left-32 top-5 z-[-1] pointer-events-none"
        src={line}
        alt="line"
      />
      <img
        className="absolute hidden md:block right-32 top-5 z-[-1] pointer-events-none"
        src={line}
        alt="line"
      />
      <img
        className="absolute hidden xl:block left-1/2 -translate-x-1/2 bottom-0 z-[-1] pointer-events-none transform scale-y-[-1]"
        src={line}
        alt="line"
      />
      {howItWorkList.map((item, index) => (
        <div
          key={index}
          className="flex items-center gap-[31px] w-full bg-[#DDEFF6] px-4 py-5 rounded-[12px] hover:shadow-[0px_7px_22.1px_0px_#f6f6f6] hover:-translate-y-1 duration-200"
        >
          <div className="flex flex-col items-center w-full">
            <div className="flex items-center justify-center">
              <span>{item.icon}</span>
            </div>
            <h3 className="font-semibold text-base leading-[130%] text-[#010101] pt-5 uppercase text-center">
              {item.title}
            </h3>
            <p className="font-normal text-center text-base leading-[160%] text-black/90 opacity-70 pt-3">
              {item.description}
            </p>
            <p className="font-normal text-center text-base leading-[160%] text-black/90 opacity-70 pt-1">
              {item.description2}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default HowItWorksCard;
